import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
} from 'reactstrap';
import Table from './table';
import Actions from './actions';
import NotesModal from './modals/NotesModal';
import useDidMountEffect from '../../../../shared/hooks/useDidMountEffect';
import { parseUrl } from '../../../../shared/helpers/WVUtilities';
import { getConstant } from '../../../../shared/helpers/WVConstants';
import TrinityResult from '../../ConfirmedDeals/components/modals/TrinityResult';

const approvalStatusMap = {
  Approved: 'approved',
  'Need Review': 'inReview',
  Rejected: 'rejected',
  Pending: 'hold',
};

const getApprovalStatusInitial = () => {
  const filters = parseUrl();
  const initial = {
    Approved: false,
    'Need Review': true,
    Pending: false,
    Rejected: false,
  };
  if (filters?.approvalsBrandStatus) {
    const selected = Array.isArray(filters.approvalsBrandStatus) ? filters.approvalsBrandStatus : [filters.approvalsBrandStatus];
    Object.keys(initial).forEach((label) => {
      initial[label] = selected.includes(approvalStatusMap[label]);
    });
  }
  return initial;
};

const getJustificationInitial = () => {
  const filters = parseUrl();
  const justificationOptions = getConstant('deal', 'dealJustification') || [];
  const initial = {};
  justificationOptions.forEach((opt) => {
    initial[opt] = true;
  });
  if (filters?.dealJustification) {
    const selected = Array.isArray(filters.dealJustification) ? filters.dealJustification : [filters.dealJustification];
    Object.keys(initial).forEach((key) => {
      initial[key] = selected.includes(key);
    });
  }
  return initial;
};

const PriceApprovalContainer = ({
  setTag,
  action,
  resource,
  history,
}) => {
  const filters = parseUrl();
  const [loading, setLoading] = useState(true);
  const [version, setVersion] = useState((new Date()).toString());
  const [selectedIds, setSelectedIds] = useState([]);
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [currentProspect, setCurrentProspect] = useState({});
  const [approvalStatusFilters, setApprovalStatusFilters] = useState(getApprovalStatusInitial());
  const [justificationFilters, setJustificationFilters] = useState(getJustificationInitial());
  const [searchValue, onSearchChange] = useState(filters.fullSearchName || '');
  const [categoryValue, onCategoryChange] = useState(filters.category || '');
  const [selectedCountries, setSelectedCountries] = useState(
    filters.countryOfResidence
      ? (Array.isArray(filters.countryOfResidence) ? filters.countryOfResidence : [filters.countryOfResidence])
      : [],
  );

  console.log(selectedIds);

  const getUrlSearch = () => {
    const search = new URLSearchParams(window.location.search);
    if (searchValue) {
      search.set('filters.fullSearchName', searchValue);
    } else {
      search.delete('filters.fullSearchName');
    }
    if (categoryValue) {
      search.set('filters.category', categoryValue);
    } else {
      search.delete('filters.category');
    }
    if (approvalStatusFilters && Object.keys(approvalStatusFilters).length > 0) {
      search.delete('filters.approvalsBrandStatus');
      Object.keys(approvalStatusFilters).forEach((label) => {
        if (!approvalStatusFilters[label]) return false;
        search.append('filters.approvalsBrandStatus', approvalStatusMap[label]);
        return true;
      });
    }
    if (justificationFilters && Object.keys(justificationFilters).length > 0) {
      search.delete('filters.dealJustification');
      Object.keys(justificationFilters).forEach((key) => {
        if (!justificationFilters[key]) return false;
        search.append('filters.dealJustification', key);
        return true;
      });
    }
    search.delete('filters.countryOfResidence');
    if (selectedCountries && selectedCountries.length > 0) {
      selectedCountries.forEach((val) => {
        search.append('filters.countryOfResidence', val);
      });
    }
    return search;
  };

  const setUrl = (setFirstPage = false) => {
    const search = getUrlSearch();
    if (setFirstPage) {
      search.set('page', '1');
    }
    history.push(`${history.location.pathname}?${search.toString()}`);
  };

  useDidMountEffect(() => {
    setUrl(true);
    setLoading(false);
  }, [
    approvalStatusFilters,
    justificationFilters,
    searchValue,
    categoryValue,
    selectedCountries,
  ]);

  useEffect(() => {
    setUrl(false);
    setLoading(false);
  }, []);

  const handleCountryChange = (data) => {
    setSelectedCountries(data ? data.map(d => d.value) : []);
  };

  return (
    <Container className="dashboard">
      <Row>
        <Col md="3">
          <h2 style={{ marginBottom: '25px' }}>Brand Price Approval</h2>
        </Col>
      </Row>
      <Card>
        <CardBody>
          <Actions
            approvalStatusFilters={approvalStatusFilters}
            setApprovalStatusFilters={setApprovalStatusFilters}
            justificationFilters={justificationFilters}
            setJustificationFilters={setJustificationFilters}
            onSearchChange={onSearchChange}
            searchValue={searchValue}
            onCategoryChange={onCategoryChange}
            categoryValue={categoryValue}
            selectedCountries={selectedCountries}
            onCountryChange={handleCountryChange}
            searchQuery={getUrlSearch().toString()}
          />
        </CardBody>
      </Card>
      <Row>
        {!loading && (
          <Col>
            <Table
              setTag={setTag}
              action={action}
              resource={resource}
              version={version}
              setSelectedIds={setSelectedIds}
              setCurrentProspect={setCurrentProspect}
              setShowNotesModal={setShowNotesModal}
            />
          </Col>
        )}
      </Row>
      <NotesModal isOpen={showNotesModal} closeFunc={() => setShowNotesModal(false)} setVersion={setVersion} prospect={currentProspect} />
      <TrinityResult />
    </Container>
  );
};

PriceApprovalContainer.propTypes = {
  setTag: PropTypes.func.isRequired,
  action: PropTypes.objectOf(PropTypes.any).isRequired,
  resource: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    location: PropTypes.objectOf(PropTypes.any).isRequired,
  }).isRequired,
};

export default PriceApprovalContainer;
